import {useMatchMedia} from '@pexip/hooks';

import {XS} from '../../constants/mediaQueries';

export const useXs = () => useMatchMedia(XS);
